module.exports = __webpack_public_path__ + "static/img/negy_2.26f76f1.jpg";


//////////////////
// WEBPACK FOOTER
// ./src/3dapps/skybox/tidepool/negy_2.jpg
// module id = JO9A
// module chunks = 2